module.exports = __webpack_public_path__ + "img/ecn_plate_Img.94b14285.png";